import { Box, Tooltip, Typography } from "@mui/material";

interface CoverageBarProps {
  eligible: number;
  success: number;
  inProgress: number;
  failed: number;
  missing: number;
  onClick: () => void;
}

export default function CoverageBar({ eligible, success, inProgress, failed, missing, onClick }: CoverageBarProps) {
  if (eligible === 0) return <>—</>;
  const pct = (n: number) => (n / eligible) * 100;
  const successPct = Math.round((success / eligible) * 100);
  const tooltip = `${success} succeeded · ${inProgress} in progress · ${failed} failed · ${missing} missing — click for details`;
  return (
    <Tooltip title={tooltip}>
      <Box
        onClick={onClick}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          cursor: "pointer",
          "&:hover": { opacity: 0.85 },
        }}
      >
        <Box
          sx={{
            flexGrow: 1,
            height: 8,
            borderRadius: 4,
            display: "flex",
            overflow: "hidden",
            bgcolor: "grey.300",
          }}
        >
          <Box sx={{ width: `${pct(success)}%`, bgcolor: "success.main" }} />
          <Box sx={{ width: `${pct(inProgress)}%`, bgcolor: "info.main" }} />
          <Box sx={{ width: `${pct(failed)}%`, bgcolor: "error.main" }} />
        </Box>
        <Typography variant="caption">{successPct}%</Typography>
      </Box>
    </Tooltip>
  );
}
